import { useState } from 'react'
import { CATEGORIES } from '../constants/furniture'

export default function InputForm({ onSizeChange, hideHeader = false, isRoomSettingsExpanded = true }) {
    const [isOpen, setIsOpen] = useState(true)

    const handleCategoryClick = (categoryId) => {
        const category = CATEGORIES.find(c => c.id === categoryId)
        onSizeChange({
            ...category.defaultSize,
            categoryId: categoryId,
            action: 'add'
        })
    }

    // hideHeaderがtrueの場合、常に展開状態でヘッダーなし
    const showContent = hideHeader || isOpen

    // 部屋設定が閉じている時はカテゴリグリッドを広げる（PC版のみ）
    // モバイル（hideHeader）の場合はmax-height制限なし
    // 下部のロゴ（bottom-6 + ロゴ高さ約80px + 間隔16px）を考慮
    const categoryMaxHeight = hideHeader
        ? ''
        : (isRoomSettingsExpanded ? 'max-h-[calc(100vh-490px)]' : 'max-h-[calc(100vh-380px)]')

    return (
        <div className={hideHeader ? "space-y-4" : "glass-effect rounded-2xl p-6 space-y-6"}>
            {/* タイトル - hideHeaderがfalseの場合のみ表示 */}
            {!hideHeader && (
                <div
                    className="flex justify-between items-center cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <div>
                        <h2 className="text-lg font-semibold text-white mb-1">家具選択</h2>
                        <p className="text-xs text-gray-400">カテゴリをクリックして追加</p>
                    </div>
                    <span className="text-white text-xl">{isOpen ? '−' : '＋'}</span>
                </div>
            )}

            {showContent && (
                <>
                    {/* カテゴリ選択 */}
                    <div>
                        <label className="block text-sm font-medium text-gray-300 mb-3">カテゴリ</label>
                        <div className={`${categoryMaxHeight} overflow-y-auto scrollbar-hide`}>
                            <div className="grid grid-cols-3 gap-2">
                                {CATEGORIES.map((category) => (
                                    <button
                                        key={category.id}
                                        onClick={() => handleCategoryClick(category.id)}
                                        className="p-3 rounded-xl text-center transition-all duration-200 bg-white/5 text-gray-400 hover:bg-primary-500/30 hover:text-white active:scale-95"
                                    >
                                        <div className="text-2xl mb-1">{category.icon}</div>
                                        <div className="text-xs font-medium">{category.name}</div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

